import { r as d, x as c, c as w } from "../lit-element-8JrrHldg.js";
import { n as u } from "../property-4FoNj0Pi.js";
import { r as p } from "../state-D4BCZ2JK.js";
import { c as f } from "../clsx-DB4S2d7J.js";
import "./pwc-icon.js";
import "../warning-hex-filled-CZflkO7j.js";
let M = class extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.255 14.686a.5.5 0 0 0 .245.064h13a.499.499 0 0 0 .444-.73l-6.5-12.5a.5.5 0 0 0-.888 0l-6.5 12.5a.5.5 0 0 0 .199.666ZM8.5 5.75h-1v4.5h1v-4.5Zm-.5 5.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z" clip-rule="evenodd"></path></svg>';
  }
};
const g = "pi-warning-filled";
customElements.get(g) || customElements.define(g, M);
class v extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.111 2.18a7 7 0 1 1 7.778 11.64A7 7 0 0 1 4.111 2.18ZM4.5 8.207l2.5 2.5 4.5-4.5-.707-.707L7 9.293 5.207 7.5l-.707.707Z" clip-rule="evenodd"></path></svg>';
  }
}
const m = "pi-checkmark-circle-filled";
customElements.get(m) || customElements.define(m, v);
var _ = Object.defineProperty, x = Object.getOwnPropertyDescriptor, l = (e, s, r, n) => {
  for (var a = n > 1 ? void 0 : n ? x(s, r) : s, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(s, r, a) : o(a)) || a);
  return n && a && _(s, r, a), a;
};
const h = "pwc-input-message";
let t = class extends d {
  constructor() {
    super(...arguments), this._message = null, this.status = null;
  }
  createRenderRoot() {
    return this;
  }
  updateStatus() {
    var e, s, r;
    this.status = (e = this.errorMessages) != null && e.length ? "error" : (s = this.warningMessages) != null && s.length ? "warning" : (r = this.successMessages) != null && r.length ? "success" : null;
  }
  get message() {
    const { errorMessages: e, warningMessages: s, successMessages: r, hintMessage: n } = this, a = (i) => Array.isArray(i) ? i[0] : i;
    return e != null && e.length ? a(e) : s != null && s.length ? a(s) : r != null && r.length ? a(r) : n || null;
  }
  get icon() {
    return this.status ? t.icon[this.status] : null;
  }
  updated(e) {
    super.updated(e), (e.has("errorMessages") || e.has("warningMessages") || e.has("successMessages") || e.has("hintMessage")) && (this._message && !this.message ? setTimeout(() => {
      this.message || (this.updateStatus(), this._message = this.message);
    }, t.outDuration) : (this.updateStatus(), this._message = this.message));
  }
  render() {
    const { status: e, _message: s, message: r, icon: n } = this;
    return c`
      <div
        style="--messageOutDuration: ${t.outDuration / 1e3}s"
        class=${f(
      "PwcInputMessage",
      `PwcInputMessage--${e || "idle"}`,
      {
        "PwcInputMessage--hasMessage": r
      }
    )}
      >
        <div class="PwcInputMessage__message">
          ${s ? c` ${n ? c`
                      <pwc-icon
                        class="PwcInputMessage__icon"
                        size="16px"
                        inline
                        icon="${n}"
                      ></pwc-icon>
                    ` : ""}
                <span class="PwcInputMessage__message__text">${s}</span>` : ""}
        </div>
      </div>
    `;
  }
};
t.tagName = h;
t.icon = {
  error: "warning-hex-filled",
  warning: "warning-filled",
  success: "checkmark-circle-filled"
};
t.outDuration = 300;
l([
  u({ attribute: "error-messages" })
], t.prototype, "errorMessages", 2);
l([
  u({ attribute: "success-messages" })
], t.prototype, "successMessages", 2);
l([
  u({ attribute: "warning-messages" })
], t.prototype, "warningMessages", 2);
l([
  u({ type: String, attribute: "hint-message" })
], t.prototype, "hintMessage", 2);
l([
  p()
], t.prototype, "_message", 2);
l([
  p()
], t.prototype, "status", 2);
t = l([
  w(h)
], t);
export {
  t as default
};
